import styled from "styled-components";

const HeaderContainer = styled.div`
  width: 100%; min-height: 60px;
  padding-left: 20px;
  display: flex;
  grid-area: header;
  align-items: center;
  justify-content: space-between;
`;

export default HeaderContainer;
